//this file is for Utilities page where all client to server communication actions are implemented

import axios from "axios";
import { ErrorMessage } from "../Utils/Utils";
import { JsonConfig, BaseUrl, FormConfig, UserName, } from "./BaseRepository"

//this function will fetch default term date headers for template
export const FetchTermDateTemplateHeaders = async () => {
    try {
        const Url = BaseUrl + "Paychex/getTermdateTemplate";
        const response = await axios.get(Url, JsonConfig);
        return JSON.parse(response.data);
    }
    catch (error) {
        ErrorMessage("Unable to get Term Date template");
        return null;
    }
}

//function will post term date excel file as form data object to the server
export const PostTermDateFile = async (formData) => {
    try {
        const Url = BaseUrl + "Paychex/termdateupdate?UserName=" + UserName;
        const response = await axios.post(Url, formData, FormConfig);
        if (response != null) {
            console.log(response);
            return response.data;
        }
    }
    catch (error) {
        ErrorMessage("Unable to get Term Date template");
        return null;
    }
}